import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IEmpleo, IDeleteEmpleoResponse, IUpdateEmpleoResponse } from '../../interfaces/empleos.interface';
import {
  CreateEmpleo, CreateEmpleoSuccess, DeleteEmpleo, DeleteEmpleoSuccess,
  GetEmpleos, GetEmpleosSuccess, UpdateEmpleo, UpdateEmpleoSuccess
} from '../actions/empleos.actions';

@Injectable()
export class EmpleosEffects {
  getEmpleos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetEmpleos),
      switchMap(() =>
        this.apiService.getEmpleos().pipe(
          map((empleos: IEmpleo[]) => GetEmpleosSuccess({ empleos }))
        )
      )
    )
  );

  createEmpleo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateEmpleo),
      switchMap(payload =>
        this.apiService.createEmpleo(payload.empleo).pipe(
          map((empleo: IEmpleo) => CreateEmpleoSuccess({ empleo }))
        )
      )
    )
  );

  deleteEmpleo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteEmpleo),
      switchMap(payload =>
        this.apiService.deleteEmpleo(payload.id).pipe(
          map((empleo: IDeleteEmpleoResponse) => DeleteEmpleoSuccess({ empleo }))
        )
      )
    )
  );

  updateEmpleo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateEmpleo),
      switchMap(payload =>
        this.apiService.updateEmpleo(payload.id, payload.empleo).pipe(
          map((empleo: IUpdateEmpleoResponse) => UpdateEmpleoSuccess({ empleo }))
        )
      )
    )
  );

  constructor(
    private apiService: ApiService,
    private actions$: Actions,
    private store: Store<IAppState>
  ) { }
}
